import { Provider } from 'react-redux';

import Router from './modules/navigation/Router';
import store from './redux';

import './App.css';
import ErrorBoundary from './modules/core/ErrorBoundary';
import { Alert, ConfigProvider } from 'antd';
import es_ES from 'antd/lib/locale/es_ES';

import 'moment/locale/es';
import ThemeProvider from './modules/core/Theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 5 * 60 * 1000,
            staleTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false,
        },
    },
});

const isProductionDomain = () => {
    const hostname = window.location.hostname;
    return hostname === 'qr.intrena.co';
};
const App = () => (
    <ThemeProvider>
        <ConfigProvider locale={es_ES}>
            <QueryClientProvider client={queryClient}>
                <ErrorBoundary>
                    <Provider store={store}>
                        {!isProductionDomain() && (
                            <Alert
                                message="Esta es una versión de pruebas, por favor no generar QRs ni ningún otro tipo de entregables ya que pueden quedar mal configurados."
                                banner
                            />
                        )}
                        <Router />
                    </Provider>
                </ErrorBoundary>
            </QueryClientProvider>
        </ConfigProvider>
    </ThemeProvider>
);

export default App;
